// Final winners use these clips; answer reactions keep their ordinary celebrate.
// Importing URLs does not download the roster. Load only the current winners.
const files = import.meta.glob('../assets/avatar-trophies/*.webp', {
  eager: true, query: '?url', import: 'default',
});

const roster = [
  ['🥷', 'ninja'], ['🦄', 'unicorn'], ['🐙', 'octopus'], ['🦖', 'dino'],
  ['💃', 'dancer-woman'], ['🕺', 'dancer-man'], ['🐲', 'dragon'], ['👽', 'alien'],
  ['💀', 'skeleton'], ['🧸', 'teddy'], ['🩷', 'pink-heart'], ['🍇', 'grapes'],
  ['👑', 'crown'], ['👻', 'ghost'], ['🤖', 'robot'], ['🐤', 'baby-chick'],
];

export const AVATAR_TROPHIES = Object.freeze(Object.fromEntries(roster.map(([emoji, id]) => [
  emoji,
  Object.freeze({
    id,
    src: files[`../assets/avatar-trophies/${id}-trophy.webp`],
    poster: files[`../assets/avatar-trophies/${id}-trophy.static.webp`],
    start: files[`../assets/avatar-trophies/${id}-trophy-start.static.webp`],
    durationMs: 5042,
    width: 384,
    height: 384,
    placement: Object.freeze({ scale: 1, x: 0, y: 100 * 16 / 384 }),
  }),
])));

export function getAvatarTrophy(emoji) {
  return Object.hasOwn(AVATAR_TROPHIES, emoji) ? AVATAR_TROPHIES[emoji] : null;
}
